module.exports = __webpack_public_path__ + "media/KZ-KAR.bfdd5d22.ogg";